// extracted by mini-css-extract-plugin
export default {"cls1":"ItH1_ruuF_R8yboNCW5V","cls2":"QzsqwBoM99sekt_o64SC ItH1_ruuF_R8yboNCW5V"};